export default class EmailNotConfirmedError<Data = unknown> extends Error {
  name = 'EmailNotConfirmed';

  constructor(readonly message = 'Email not confirmed', readonly data?: Data) {
    super(message);
  }
}
